export const branches = [
  {
    id: 1,
    name: 'Durango',
    slug: 'durango',
    menuSubdomain: 'dgo',
    whatsapp: '6181697164',
    displayPhone: '618 169 7164',
    hasBreakfast: false,
    hasLargeScreens: false,
    hasLiveMusic: true,
  },
];

export const getDefaultBranchId = () => branches[0]?.id ?? 1;

export const getBranchById = (id) => branches.find((branch) => branch.id === id) ?? branches[0];

export const getBranchIdFromRoute = (route) => {
  if (!route) {
    return getDefaultBranchId();
  }

  const parts = route.split('/');
  const match = branches.find((branch) => branch.slug === parts[1]);

  return match?.id ?? getDefaultBranchId();
};

export const getMenuUrl = (branch) => `https://${branch.menuSubdomain}.taquitogrill.com`;

export const getWhatsappUrl = (branch, message) => {
  const base = `https://wa.me/52${branch.whatsapp}`;
  if (!message) {
    return base;
  }
  return `${base}?text=${encodeURIComponent(message)}`;
};

export const formatBranchList = (list) => {
  if (list.length === 1) {
    return list[0];
  }
  if (list.length === 2) {
    return list.join(' y ');
  }
  return `${list.slice(0, -1).join(', ')} y ${list[list.length - 1]}`;
};
